module.exports = __webpack_public_path__ + "img/bj.e4053178.png";